import { useTranslation } from "react-i18next";
import { FiMapPin, FiPhone, FiClock, FiMail, FiStar, FiNavigation } from "react-icons/fi";
import CalismaRozeti from "./CalismaRozeti";
import { GOOGLE_HARITA_URL } from "../data/isletme";

const Magazalarimiz = () => {
  const { t } = useTranslation();

  // Mağaza verilerini i18n key'lerinden alıyoruz
  const stores = [
    {
      id: 1,
      city: t("stores.istanbul.city"),
      name: t("stores.istanbul.name"),
      address: t("stores.istanbul.address"),
      phone: t("stores.istanbul.phone"),
      email: t("stores.istanbul.email"),
      hours: t("stores.istanbul.hours"),
      image: "/images/magazaIstanbulFoto.png",
      mapUrl:
        "https://www.google.com/maps/embed?pb=!3m2!1str!2str!4v1751112459469!5m2!1str!2str!6m8!1m7!1s5-VC5qO4YmT24b30YfKoBg!2m2!1d40.99933901662759!2d28.90147760670103!3f327.43168930977185!4f-1.9137708430491358!5f0.7820865974627469",
    },
    {
      id: 2,
      city: t("stores.ankara.city"),
      name: t("stores.ankara.name"),
      address: t("stores.ankara.address"),
      phone: t("stores.ankara.phone"),
      email: t("stores.ankara.email"),
      hours: t("stores.ankara.hours"),
      image: "/images/magazaAnkaraFoto.png",
      mapUrl:
        "https://www.google.com/maps/embed?pb=!3m2!1str!2str!4v1751112558771!5m2!1str!2str!6m8!1m7!1ss3ofBmb1YvcOPDS-LxHyRA!2m2!1d41.00314375032697!2d28.90285322133603!3f77.29313497660245!4f4.11522564512029!5f0.7820865974627469",
    },
  ];

  return (
    <section className="container-page section">
      {/* Başlık */}
      <div className="page-head">
        <h1 className="page-title">{t("stores.title")}</h1>
        <p className="page-sub">{t("stores.subtitle")}</p>
      </div>

      {/* Canlı durum + Google */}
      <div className="mb-8 flex flex-col gap-4 rounded-2xl border border-line bg-canvas/60 p-5 sm:flex-row sm:items-center sm:justify-between sm:p-6">
        <div>
          <CalismaRozeti />
          <p className="mt-2 text-[13.5px] text-muted">{t("reviews.storesText")}</p>
        </div>
        <div className="flex flex-wrap gap-2">
          <a
            href={GOOGLE_HARITA_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-md border border-line bg-white px-4 py-2.5 text-[13.5px] font-semibold text-ink transition-colors hover:border-ink"
          >
            <FiStar size={15} className="text-amber-500" aria-hidden="true" />
            {t("reviews.readOnGoogle")}
          </a>
          <a
            href={GOOGLE_HARITA_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-md bg-ink px-4 py-2.5 text-[13.5px] font-semibold text-white transition-opacity hover:opacity-90"
          >
            <FiNavigation size={14} aria-hidden="true" />
            {t("reviews.directions")}
          </a>
        </div>
      </div>

      {/* Mağaza Kartları */}
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
        {stores.map((store) => (
          <article
            key={store.id}
            className="overflow-hidden rounded-lg border border-line bg-white"
          >
            <div className="h-56 overflow-hidden bg-canvas sm:h-64 lg:h-72">
              <img
                src={store.image}
                alt={store.city}
                className="h-full w-full object-cover object-center"
              />
            </div>

            {/* Detaylar */}
            <div className="border-t border-line p-6">
              <p className="eyebrow">{store.city}</p>
              <h2 className="mt-2 text-[18px] font-semibold text-ink">
                {store.name}
              </h2>

              <div className="mt-5 space-y-3 text-[14px]">
                <div className="flex items-start gap-3">
                  <FiMapPin
                    className="mt-0.5 shrink-0 text-muted"
                    size={16}
                    aria-hidden="true"
                  />
                  <p className="text-body">{store.address}</p>
                </div>

                <div className="flex items-start gap-3">
                  <FiPhone
                    className="mt-0.5 shrink-0 text-muted"
                    size={16}
                    aria-hidden="true"
                  />
                  <p className="text-body">{store.phone}</p>
                </div>

                <div className="flex items-start gap-3">
                  <FiMail
                    className="mt-0.5 shrink-0 text-muted"
                    size={16}
                    aria-hidden="true"
                  />
                  <p className="text-body">{store.email}</p>
                </div>

                <div className="flex items-start gap-3">
                  <FiClock
                    className="mt-0.5 shrink-0 text-muted"
                    size={16}
                    aria-hidden="true"
                  />
                  <p className="text-body">{store.hours}</p>
                </div>
              </div>
            </div>

            {/* Harita */}
            <div className="border-t border-line">
              <iframe
                title={`${store.city} Map`}
                src={store.mapUrl}
                className="h-48 w-full sm:h-64"
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Magazalarimiz;
